<template>
  <div
    id="content_row_blog"
    class="seasidetms_row seasidetms_color_scheme_default seasidetms_row_top_default seasidetms_row_bot_default seasidetms_row_boxed"
  >
    <div class="seasidetms_row_outer_parent">
      <div class="seasidetms_row_outer">
        <div class="seasidetms_row_inner" style="padding: 0">
          <div class="seasidetms_row_margin">
            <div class="h3 seasidetms_heading" style="margin-left: 10px">
              {{ title }}
            </div>
            <preloader v-if="loading" />
            <div v-else>
              <section class="blog-slider">
                <aside class="box" v-for="(post, i) in posts" :key="`r${i}`">
                  <div class="content">
                    <figure class="seasidetms_product_img">
                      <router-link
                        :to="
                          lang
                            ? '/' +
                              lang +
                              '/blog/' +
                              encodeURIComponent(post.slug)
                            : '/blog/' + encodeURIComponent(post.slug)
                        "
                      >
                        <img
                          width="300"
                          height="300"
                          :src="postImgSrc(post)"
                          :alt="postTitle(post)"
                          class="attachment-medium size-medium"
                        />
                        <!-- srcset="
                            https://tech-store.seaside-themes.com/wp-content/uploads/2017/09/35-300x300.jpg 300w,
                            https://tech-store.seaside-themes.com/wp-content/uploads/2017/09/35-150x150.jpg 150w,
                            https://tech-store.seaside-themes.com/wp-content/uploads/2017/09/35.jpg 600w,
                            https://tech-store.seaside-themes.com/wp-content/uploads/2017/09/35-75x75.jpg 75w,
                            https://tech-store.seaside-themes.com/wp-content/uploads/2017/09/35-580x580.jpg 580w,
                            https://tech-store.seaside-themes.com/wp-content/uploads/2017/09/35-540x540.jpg 540w,
                            https://tech-store.seaside-themes.com/wp-content/uploads/2017/09/35-100x100.jpg 100w
                          "
                          sizes="(max-width: 300px) 100vw, 300px" -->
                      </router-link>
                    </figure>
                    <router-link
                      :to="
                        lang
                          ? '/' +
                            lang +
                            '/blog/' +
                            encodeURIComponent(post.slug)
                          : '/blog/' + encodeURIComponent(post.slug)
                      "
                    >
                      <div class="h4" style="margin-bottom: 10px">
                        {{ postTitle(post) }}
                      </div>
                    </router-link>
                    {{ postDescription(post) }}
                  </div>
                </aside>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Preloader from '@/components/Preloader'

export default {
  name: 'BlogSlider',
  components: { Preloader },
  data() {
    return {
      loading: true,
      lang: '',
    }
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    posts() {
      if (
        Array.isArray(this.$store.state.blog.posts) &&
        this.$store.state.blog.posts.length
      ) {
        return this.$store.state.blog.posts.slice(0, 3)
        // .map(v => this.$h.stripHTML(v.description))
      } else {
        return []
      }
    },
  },
  methods: {
    postTitle(post) {
      return post[`name_${this.$i18n.locale}`]
        ? post[`name_${this.$i18n.locale}`]
        : post.name || ''
    },
    postDescription(post) {
      return post[`short_description_${this.$i18n.locale}`]
        ? post[`short_description_${this.$i18n.locale}`]
        : ''
    },
    postImgSrc(post) {
      return post.photo ? `/img${post.photo}` : 'data:,'
    },
  },
  created() {
    if (
      !(
        Array.isArray(this.$store.state.blog.posts) &&
        this.$store.state.blog.posts.length
      )
    ) {
      this.$store
        .dispatch('fetchBlog')
        .then(() => {
          this.loading = false
        })
        .catch((err) => {
          console.log('*err', err)
        })
    } else {
      this.loading = false
    }
  },
  beforeMount() {
    this.lang = this.$store.getters.lang
  },
  updated() {
    this.lang = this.$store.getters.lang
  },
}
</script>

<style scoped>
.blog-slider {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 50px;
}
.box {
  flex-basis: 30%;
  border: 1px solid #dddddd;
  border-radius: 10px;
  margin: 10px;
}
.box figure {
  margin-bottom: 15px;
}
.content {
  width: 100%;
  min-height: 100px;
  padding: 10px;
}
@media only screen and (max-width: 768px) {
  .box {
    flex-basis: 100%;
  }
}
</style>
